export default __webpack_public_path__ + "static/media/Backcover.b4e09c97.txt";